import { render, staticRenderFns } from "./CountTextArea.vue?vue&type=template&id=d4018ce4&scoped=true&"
import script from "./CountTextArea.vue?vue&type=script&lang=ts&"
export * from "./CountTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./CountTextArea.vue?vue&type=style&index=0&id=d4018ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4018ce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
